var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contactMe__container"},_vm._l((_vm.contacts),function(contact,idx){return _c('div',{key:idx,staticClass:"contact__item"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(contact.label))]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(contact.value))]),_vm._v(" "),_c('div',{staticClass:"separator"})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff3c16de","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AboutMe/DetailDescription/ContactMe.vue
// module id = B8Ix
// module chunks = 0